const styles = () => ({
  link: {
    display: 'block',
    padding: 0,
    height: 'auto'
  }
})

export default styles
